import { render, staticRenderFns } from "./BuscarVehiculo.vue?vue&type=template&id=6fcb5fe7&"
import script from "./BuscarVehiculo.vue?vue&type=script&lang=js&"
export * from "./BuscarVehiculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports